import axios from "axios";
import { loadModules } from "esri-loader";

export default class TableService {
  constructor() {}

  static queryArcGISServerLayer(url, options) {
    return loadModules(["esri/core/urlUtils"]).then(([urlUtils]) => {      
      const proxyRule = urlUtils.getProxyRule(url);
      if (proxyRule) {
        url = proxyRule.proxyUrl + url;
      }
      return axios.get(url, options);

    });
  }
}
